import { render, staticRenderFns } from "./RubrosHijos.vue?vue&type=template&id=16cf98fd&scoped=true"
import script from "./RubrosHijos.vue?vue&type=script&lang=js"
export * from "./RubrosHijos.vue?vue&type=script&lang=js"
import style0 from "./RubrosHijos.vue?vue&type=style&index=0&id=16cf98fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cf98fd",
  null
  
)

export default component.exports